import React from 'react'
import { Divider } from 'components/Calendar/style'
import Button from 'components/Common/Button'
import { ParagraphWrapper } from 'components/Owner/PlayBooksCategoryDetails/TakePlaysToast/styles'
import { USER_ROLES } from 'config/enums'
import { useTenantId } from 'utils/useTenantId'
import { ButtonParentWrapper, ButtonWrapper, SmsHeadingWrapper, SmsParentWrapper } from './style'
import { isFunctionEmpty, smsSubscriptionAmpliLog } from 'utils/helper'
import { AppFC, ISmsSubscriptionNotification } from 'types'

const SmsUnsubscribeNotification: AppFC<ISmsSubscriptionNotification> = ({
  user,
  onSubmit,
  isLoading,
  moveToNext,
  handleBack,
  isWelcomeScreen,
  progressBarAction,
}) => {
  const tenantId = useTenantId()
  return (
    <SmsParentWrapper isWelcomeScreen={isWelcomeScreen}>
      <SmsHeadingWrapper isWelcomeScreen={isWelcomeScreen}>Are you sure?</SmsHeadingWrapper>
      <ParagraphWrapper className=" text-lg leading-6 !text-black-light mt-3 font-semibold">
        You'll miss out on notifications{' '}
        {`${user.roles?.includes(USER_ROLES.BSO_ADVISOR) ? 'from your clients' : ''}`} and important
        updates about the product.
      </ParagraphWrapper>
      {!isWelcomeScreen && <Divider />}
      <ButtonParentWrapper isWelcomeScreen={!isFunctionEmpty(handleBack)}>
        {handleBack && (
          <Button
            className="!h-16"
            type="button"
            label="Back"
            variant="secondary"
            onClick={handleBack}
          />
        )}
        <ButtonWrapper isWelcomeScreen={!isFunctionEmpty(handleBack)}>
          <Button
            onClick={() => {
              onSubmit({
                isSmsEnabled: false,
                tenantId,
              })
              if (moveToNext && progressBarAction) {
                moveToNext()
                progressBarAction()
              }
              smsSubscriptionAmpliLog(user, 'UnSubscribed')
            }}
            disabled={isLoading}
            variant="primary"
            type="button"
            label="Don't Subscribe"
          ></Button>
        </ButtonWrapper>
      </ButtonParentWrapper>
    </SmsParentWrapper>
  )
}
SmsUnsubscribeNotification.defaultProps = {
  handleBack: undefined,
  moveToNext: undefined,
  isWelcomeScreen: false,
  progressBarAction: undefined,
}

export default SmsUnsubscribeNotification
